import { DeskData } from '@/datamodel/deskdata'
import { PopAlertModel, RoadMapSummaryData } from '@/datamodel/types'
import { Vue, Options } from 'vue-class-component'
import { Action, Getter } from 'vuex-class'
import RoadMapView from '@/components/roadmap/index.vue'
import { RoadMapData } from '@/components/roadmap/data-model'
import { DeskInfpParams } from '@/datamodel/urlparams/DeskInfoParams'
import { ResponseData } from '@/datamodel/response-data'
import audioPlayer, { SOUNDKEY } from '@/utils/sounds'
import { Watch } from 'vue-property-decorator'
import { CardInfoParams } from '@/datamodel/urlparams/CardInfoParams'
import { GameResult } from '@/datamodel/game-result'
import {
    ACT,
    EventBuss,
    GameRoundState,
    RESULT,
    SOCKET_MESSAGE
} from '@/utils/constants'
import { Dictionary } from '@/datamodel/dictionary'
import { BetViewMixin } from '@/components/desk/betview/mixin'
import { Device } from '@/store/types'
import MarqueeText from '@/components/common/marquee-text.vue'
import { isLandscape, to24HoursFormat } from '@/utils'

import screenfull, { Screenfull } from 'screenfull'
import { AxiosSource, getHallData, getTableInfo } from '@/api'
import axios, { CancelTokenSource } from 'axios'
import { useI18n } from 'vue-i18n'
import {
    BetForm,
    MemberLimit,
    RedPacket,
    ResultMemberList,
    SocketMessage,
    Table
} from 'vue'
import { store } from '@/store'
import { UserMutation } from '@/store/module/user'
import router, { ROUTES } from '@/router'
import { DeskMutation } from '@/store/module/desk'
import { useRoute } from 'vue-router'
import RedEnvelop2 from '@/components/dialogs/red-envelop-2.vue'
import {
    countGoodRoadTables,
    filterGoodRoadGameTables
} from '@/components/desk/good-road/utils'

@Options({
    components: {
        RoadMapView,
        'marquee-text': MarqueeText,
        'red-envelop-2': RedEnvelop2
    }
})
export class DeskMixin extends Vue {
    iN = useI18n().t
    messageCounter = 0
    messageInterval: number | boolean = false

    isLandscapeMode = isLandscape()

    showSwitcher = false
    showCustumChip = false
    showSettings = false
    showPasswordForm = false
    showHistory = false
    showRule = false

    showLimitDialog = false

    // isSuper6Mode = false
    isSuper6Mode = false
    hasConfirmedBet = false

    roadMapSummaryData: RoadMapSummaryData = {}
    nextRedRoadMapSummaryData: RoadMapSummaryData = {}
    nextBlueRoadMapSummaryData: RoadMapSummaryData = {}

    showSwicthTable = false
    showGoodRoadPanel = false
    goodRoadCount = 0
    goodRoadTablesCache: Table[] = []

    router = useRoute()

    deskResult = ''
    gameChips: number[] = []

    videoIsLoading = true
    isNoticeView = true
    noticeIsPaused = false

    currentCount = -1
    // needReloadUI = true

    alertTimer: number | boolean = false
    hasPopAlert = false
    alertMessage: PopAlertModel | undefined

    countDownTimer: number | boolean = false
    serviceTimeOut: number | boolean = false
    dateTimeInterval: number | boolean = false
    dateTimeStr = to24HoursFormat(new Date())

    hasPendingRequest = false

    currentGameID: string | undefined
    needRefreshGameResult = true
    currentGameResult!: GameResult | undefined
    showPokerCards = false
    // showPokerCards = true

    allowBet = false
    @Getter('currentDesk') currentDesk!: Table

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    nodePlayer!: any
    videoPlayerCollection: Array<any> = new Array<any>()

    readonly PULL_INTERVAL = 2000
    readonly PULL_CARD_INTERVAL = 1500
    cardRequestTimeout: number | boolean = false
    failureCounter = 1

    emitter!: Vue['emitter']
    $refs!: Vue['refs']
    $route!: Vue['$route']

    videos: string[] = []
    videoRequestFailure = 0
    videoRequestTimeOut: boolean | number | any = false
    videoAxiosSource?: CancelTokenSource
    videoPlayerSession = 0
    betViewKey = `bet-view-key${new Date().getTime()}`

    redConfirmedBet = 0
    blueConfirmedBet = 0
    greenConfirmedBet = 0
    redPairConfirmedBet = 0
    bluePairConfirmedBet = 0
    playStopBet = false

    showPacket2 = false
    packet2s: RedPacket[] = []

    //#region Vuex
    @Getter('betCoin') betCoin!: number
    @Getter('customChipValue') customChipValue!: number
    @Getter('chips') chips!: Array<number>
    @Getter('isFullScreen') isFullScreen!: boolean
    @Getter('deskNotice') deskNotice!: string
    @Getter('deskInfoKey') deskInfoKey!: number
    @Getter('userId') userId!: string
    @Getter('token') token!: string
    @Getter('cardResults') cardResults!: Dictionary<string>
    @Getter('currentChipIndex') chipIndex!: number
    @Getter('device') device!: Device
    @Getter('memberId') memberId!: number
    @Getter('limitId') limitId!: number
    @Getter('deskLimit') deskLimit!: MemberLimit

    @Action('setFullScreen') setFullScreen!: (isFull: boolean) => void
    @Action('destroySession') destroySession!: () => void
    @Action('showLoading') showLoading!: () => void
    @Action('hideLoading') hideLoading!: () => void
    @Action('setBetCoin') setBetCoin!: (betCoin: number) => void
    @Action('getDeskInfo') getDeskInfo!: (
        model: DeskInfpParams
    ) => Promise<ResponseData>

    @Action('getCardInfo') getCardInfo!: (
        model: CardInfoParams
    ) => Promise<string>
    @Action('setCardResultCache') setCardResultCache!: (
        cardResults: Dictionary<string>
    ) => void
    @Action('setCurrentChipIndex') setCurrentChipIndex!: (
        indexPosition: number
    ) => void

    @Action('setDeskInfoKey') setDeskInfoKey!: () => void
    //#endregion

    //#region Vue Methods
    mounted(): void {
        // begin monitoring the date and time
        this.dateTimeInterval = setInterval(() => {
            this.dateTimeStr = to24HoursFormat(new Date())
        }, 1000)

        // load the data
        this.loadData()
        this.loadGoodRoadCount()

        // this.initVideoPlayer()

        // get video infos

        // alert(window.innerHeight)
    }

    beforeMount(): void {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        this.emitter.on(EventBuss.SHOW_POP_ALERT, this.showPopAlert)

        // initialize socket listeners
        this.emitter.on(EventBuss.SOCKET_MESSAGE, this.handlesSocketMessages)
        this.emitter.on(EventBuss.TOGGLE_SMODE, this.handleToggleSMode)
        this.emitter.on(EventBuss.LOCKED_SMODE, this.handleLockSMode)
        this.emitter.on(EventBuss.BET_SUCCESS, this.handleBetSuccess)
        this.emitter.on(EventBuss.PAGE_ON_VISIBLE, this.onPageVisible)
        this.emitter.on(
            EventBuss.SOCKET_RECONNECTED,
            this.handleReconnectSuccess
        )

        this.emitter.on(EventBuss.UPDATE_NOTICE_KEY, this.updateNoticeKey)

        if (this.device.display === 1) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore
            this.emitter.on(
                EventBuss.ORIENTATION_CHANGE,
                this.OnOrientationChange
            )
        }
    }

    OnOrientationChange(): void {
        //
    }

    beforeUnmount(): void {
        // unregister events
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        this.emitter.off(EventBuss.SHOW_POP_ALERT, this.showPopAlert)

        // remove socket listeners
        this.emitter.off(EventBuss.SOCKET_MESSAGE, this.handlesSocketMessages)

        this.emitter.off(EventBuss.TOGGLE_SMODE, this.handleToggleSMode)
        this.emitter.off(EventBuss.LOCKED_SMODE, this.handleLockSMode)
        this.emitter.off(EventBuss.BET_SUCCESS, this.handleBetSuccess)
        this.emitter.off(EventBuss.PAGE_ON_VISIBLE, this.onPageVisible)
        this.emitter.off(
            EventBuss.SOCKET_RECONNECTED,
            this.handleReconnectSuccess
        )
        this.emitter.off(EventBuss.UPDATE_NOTICE_KEY, this.updateNoticeKey)

        if (this.device.display === 1) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore
            this.emitter.off(
                EventBuss.ORIENTATION_CHANGE,
                this.OnOrientationChange
            )
        }

        if (typeof this.dateTimeInterval === 'number') {
            clearInterval(this.dateTimeInterval)
            this.dateTimeInterval = false
        }

        // end service
        this.endService()
        // this.stopRequestingCard()
        // this.stopRequestingVideoInfos()
        // stop video
        this.disposeVideoPlayer()

        //stop timer countdown if its running
        this.stopCountDown()

        if (typeof this.messageInterval === 'number') {
            clearInterval(this.messageInterval)
            this.messageCounter = 0
        }
    }
    //#endregion

    //#region SOCKET MESSAGE LISTENERS
    handlesSocketMessages(_message: SocketMessage | any) {
        // console.log(_message.type.toUpperCase())
        const { type, gameTable } = _message

        const _type = (type as string).toUpperCase()

        if (_type === SOCKET_MESSAGE.NEW_GAME) {
            const sDesk = gameTable
            if (this.isSameTable(sDesk)) {
                const _gtableCopy = { ...this.currentDesk } as Table

                _gtableCopy.expand.shoeNo = sDesk.expand.shoeNo
                _gtableCopy.expand.juNo = sDesk.expand.juNo
                _gtableCopy.expand.gameNo = sDesk.expand.gameNo
                _gtableCopy.expand.daoJiShiBetTime =
                    sDesk.expand.daoJiShiBetTime

                _gtableCopy.expand.betFormList = []
                _gtableCopy.expand.xianAmount = 0
                _gtableCopy.expand.xianDuiAmount = 0
                _gtableCopy.expand.zhuangAmount = 0
                _gtableCopy.expand.zhuangDuiAmount = 0
                _gtableCopy.expand.heAmount = 0

                _gtableCopy.expand.playerOne = undefined
                _gtableCopy.expand.playerTwo = undefined
                _gtableCopy.expand.playerThree = undefined
                _gtableCopy.expand.bankerOne = undefined
                _gtableCopy.expand.bankerTwo = undefined
                _gtableCopy.expand.bankerThree = undefined
                _gtableCopy.expand.playerCount = undefined
                _gtableCopy.expand.bankerCount = undefined
                _gtableCopy.expand.whoWin = -1
                _gtableCopy.timeStamp = new Date().getTime()

                this.redConfirmedBet = 0
                this.blueConfirmedBet = 0
                this.greenConfirmedBet = 0
                this.redPairConfirmedBet = 0
                this.bluePairConfirmedBet = 0

                store.commit(DeskMutation.SET_CURRENT_DESK, _gtableCopy)

                this.playStopBet = true
                this.allowBet = true
            }
        } else if (_type === SOCKET_MESSAGE.END_GAME) {
            const sDesk = gameTable as Table
            if (this.isSameTable(sDesk)) {
                if (!sDesk.expand.bankerOne) {
                    // console.log(
                    //     'END_GAME message received for current table',
                    //     _message
                    // )

                    // toast message
                    this.emitter.emit(
                        EventBuss.TOAST_MESSAGE,
                        this.iN('prompt.inactive')
                    )

                    this.emitter.emit(EventBuss.LOG_OUT)

                    // console.log(
                    //     'END_GAME message received but no banker card info, message:',
                    //     this.iN('prompt.inactive'),
                    //     _message
                    // )
                    return
                }
                // console.log('Current desk before update', this.currentDesk)
                const _gtableCopy = { ...this.currentDesk } as Table

                _gtableCopy.expand.playerOne = sDesk.expand.playerOne
                _gtableCopy.expand.playerTwo = sDesk.expand.playerTwo
                _gtableCopy.expand.playerThree = sDesk.expand.playerThree
                _gtableCopy.expand.bankerOne = sDesk.expand.bankerOne
                _gtableCopy.expand.bankerTwo = sDesk.expand.bankerTwo
                _gtableCopy.expand.bankerThree = sDesk.expand.bankerThree
                _gtableCopy.expand.playerCount = sDesk.expand.playerCount
                _gtableCopy.expand.bankerCount = sDesk.expand.bankerCount
                _gtableCopy.expand.whoWin = sDesk.expand.whoWin
                _gtableCopy.expand.resultList = sDesk.expand.resultList

                // reset bet data
                _gtableCopy.expand.betFormList = []
                _gtableCopy.expand.xianAmount = 0
                _gtableCopy.expand.xianDuiAmount = 0
                _gtableCopy.expand.zhuangAmount = 0
                _gtableCopy.expand.zhuangDuiAmount = 0
                _gtableCopy.expand.heAmount = 0

                const memberResultList = sDesk.expand
                    .winOrLoseList as ResultMemberList[]

                // console.log(sDesk)

                // if (!_gtableCopy.expand.bankerOne) {
                //     console.warn(
                //         'No banker card info received',
                //         _gtableCopy.expand
                //     )
                // }

                this.currentGameResult = new GameResult(this.currentDesk)

                // if (!this.currentDesk.expand.bankerOne) {
                //     console.warn(
                //         'No banker card info received Current',
                //         this.currentDesk.expand
                //     )
                // }

                if (memberResultList && memberResultList.length > 0) {
                    const _memberResultInfo = memberResultList.find(
                        x => x.memberId === this.memberId
                    )

                    if (_memberResultInfo) {
                        // console.log('WIN OR LOST', _memberResultInfo)

                        store.commit(
                            UserMutation.SET_BET_COIN,
                            _memberResultInfo.amount
                        )

                        if (_memberResultInfo.winResult !== 0) {
                            let _amtStr = '0'

                            if (_memberResultInfo.winResult > 0)
                                _amtStr = `+${_memberResultInfo.winResult}`
                            else _amtStr = String(_memberResultInfo.winResult)
                            // console.log(_amtStr, 'WIN')

                            // emitter.emit(EventBuss.SMA, _amtStr)
                            // winOrLostAmount.value = parseInt(_amtStr)

                            const popError: PopAlertModel = {
                                type: 1,
                                header: '',
                                message: _amtStr,
                                color: ''
                            }
                            const winner = this.currentGameResult.whoWin

                            if (this.gameType === 'G002') {
                                if (
                                    winner === RESULT.RED ||
                                    winner === RESULT.SUPER6
                                ) {
                                    popError.header = '庄赢'
                                    popError.color = 'banker'
                                } else if (winner === RESULT.GREEN) {
                                    popError.header = '和局'
                                    popError.color = 'tie'
                                } else {
                                    popError.header = '闲赢'
                                    popError.color = 'player'
                                }
                            } else {
                                if (winner === RESULT.DRAGON) {
                                    popError.header = '龙赢'
                                    popError.color = 'banker'
                                } else if (
                                    winner === RESULT.DRAGON_TIGER_TIE ||
                                    winner === RESULT.GREEN
                                ) {
                                    popError.header = '和局'
                                    popError.color = 'tie'
                                } else {
                                    popError.header = '虎赢'
                                    popError.color = 'player'
                                }
                            }
                            this.emitter.emit(
                                EventBuss.SHOW_POP_ALERT,
                                popError
                            )
                        }
                    }
                }

                store.commit(DeskMutation.SET_CURRENT_DESK, _gtableCopy)

                this.showPokerCards = true
                this.showGameResult()

                setTimeout(() => {
                    this.showPokerCards = false
                    this.hideGameResult()
                }, 6000)
                this.resetBetView()
            } else {
                // console.log(
                //     `END_GAME message received but table id:{${sDesk.id}} does not match current desk id:{${this.currentDesk?.id}}`
                // )
            }
        } else if (_type === SOCKET_MESSAGE.BET) {
            const sDesk = gameTable as Table

            if (this.isSameTable(sDesk)) {
                const _gtableCopy = { ...this.currentDesk } as Table

                if (sDesk.expand.memberId === this.memberId) {
                    _gtableCopy.expand.betFormList = sDesk.expand.betFormList
                    store.commit(UserMutation.SET_BET_COIN, sDesk.expand.amount)

                    // console.log('BET', sDesk.expand.betFormList)

                    this.resetBetView()
                }

                store.commit(DeskMutation.SET_CURRENT_DESK, _gtableCopy)
            }
        } else if (_type === SOCKET_MESSAGE.STOP_GAME) {
            const sDesk = gameTable as Table
            if (this.isSameTable(sDesk)) {
                const _gtableCopy = { ...this.currentDesk } as Table

                _gtableCopy.expand.daoJiShiBetTime = 0
                _gtableCopy.status = 2

                store.commit(DeskMutation.SET_CURRENT_DESK, _gtableCopy)

                this.allowBet = false

                if (this.playStopBet) {
                    this.playStopBet = false
                    audioPlayer.Play(SOUNDKEY.STOP_BET)
                }
            }
        } else if (_type === SOCKET_MESSAGE.CANCEL_GAME) {
            const sDesk = gameTable as Table

            if (this.isSameTable(sDesk)) {
                const _gtableCopy = { ...this.currentDesk } as Table
                _gtableCopy.expand.betFormList = []
                _gtableCopy.status = sDesk.status

                const memberResultList = sDesk.expand
                    .winOrLoseList as ResultMemberList[]

                if (memberResultList && memberResultList.length > 0) {
                    const _memberResultInfo = memberResultList.find(
                        x => x.memberId === this.memberId
                    )

                    if (_memberResultInfo) {
                        store.commit(
                            UserMutation.SET_BET_COIN,
                            _memberResultInfo.amount
                        )

                        this.resetBetView()
                    }

                    store.commit(DeskMutation.SET_CURRENT_DESK, _gtableCopy)
                }

                this.resetBetView()
            }
        } else if (_type === SOCKET_MESSAGE.STOP_BET) {
            const sDesk = gameTable as Table
            if (this.isSameTable(sDesk)) {
                // console.log(tableInfo.value)
                const _gtableCopy = { ...this.currentDesk } as Table
                _gtableCopy.expand.stopBet = 1

                if (sDesk.expand.amount) {
                    store.commit(UserMutation.SET_BET_COIN, sDesk.expand.amount)
                }

                this.allowBet = false

                this.resetBetView()

                if (this.playStopBet) {
                    this.playStopBet = false
                    audioPlayer.Play(SOUNDKEY.STOP_BET)
                }
            }
        } else if (_type === SOCKET_MESSAGE.NEW_SHOE) {
            const sDesk = gameTable as Table
            if (this.isSameTable(sDesk) && this.currentDesk) {
                sDesk.expand.betFormList = []

                const {
                    downLimit,
                    upLimit,
                    limitMax,
                    pairDownLimit,
                    pairUpLimit,
                    tieDownLimit,
                    tieUpLimit,
                    superSixDownLimit,
                    superSixUpLimit,
                    bearEightDownLimit,
                    bearEightUpLimit,
                    bigTigerDownLimit,
                    bigTigerUpLimit,
                    dragonSevenDownLimit,
                    dragonSevenUpLimit,
                    smallTigerDownLimit,
                    smallTigerUpLimit
                } = this.currentDesk
                sDesk.downLimit = downLimit
                sDesk.upLimit = upLimit
                sDesk.limitMax = limitMax
                sDesk.pairDownLimit = pairDownLimit
                sDesk.pairUpLimit = pairUpLimit
                sDesk.tieDownLimit = tieDownLimit
                sDesk.tieUpLimit = tieUpLimit
                sDesk.superSixDownLimit = superSixDownLimit
                sDesk.superSixUpLimit = superSixUpLimit

                sDesk.bearEightDownLimit = bearEightDownLimit
                sDesk.bearEightUpLimit = bearEightUpLimit
                sDesk.dragonSevenDownLimit = dragonSevenDownLimit
                sDesk.dragonSevenUpLimit = dragonSevenUpLimit
                sDesk.smallTigerDownLimit = smallTigerDownLimit
                sDesk.smallTigerUpLimit = smallTigerUpLimit
                sDesk.bigTigerDownLimit = bigTigerDownLimit
                sDesk.bigTigerUpLimit = bigTigerUpLimit

                store.commit(DeskMutation.SET_CURRENT_DESK, sDesk)

                this.resetBetView()
            }
        } else if (_type === SOCKET_MESSAGE.RED) {
            if (_message.userId === this.memberId) {
                const _r: RedPacket = {
                    id: -1,
                    redId: -1,
                    amount: _message.amount,
                    remark: _message.remark,
                    userId: _message.userId,
                    userType: -1,
                    userCode: _message.userCode,
                    status: -1,
                    opsTime: '',
                    endTime: _message.endTime,
                    receiveStatus: -1
                }

                this.packet2s.push(_r)
                this.showPacket2 = true
            }
        }

        this.syncGoodRoadCountFromSocket(_type, gameTable as Table)
    }

    isSameTable(s: Table): boolean {
        let isSame = false
        if (this.currentDesk && this.currentDesk.id === s.id) isSame = true

        return isSame
    }
    //#endregion

    //#region Helpers

    updateNoticeKey(): void {
        this.setDeskInfoKey()

        // console.log('NOTICE KEY UPDATED')
    }

    handleBetSuccess(obj: {
        betFormList: BetForm[]
        id: number
        amount: number
    }): void {
        if (this.currentDesk && this.currentDesk.id === obj.id) {
            const _gtableCopy = { ...this.currentDesk } as Table

            _gtableCopy.expand.betFormList = obj.betFormList
            store.commit(UserMutation.SET_BET_COIN, obj.amount)

            this.resetBetView()
            store.commit(DeskMutation.SET_CURRENT_DESK, _gtableCopy)
        }
    }

    onPacket2Close(): void {
        this.showPacket2 = false
        this.packet2s = []
    }

    handleToggleSMode(_show: boolean) {
        // console.log('TOGGLE_SMODE', _show)
        // if (this.hasConfirmedBet) return
        this.toggleSuper6Mode(_show)
    }
    handleLockSMode(_locked: boolean) {
        this.hasConfirmedBet = _locked
    }

    onPageVisible(): void {
        // console.log('PAGE ON VISIBLE')
        this.loadData(true, true)
        // this.loadGoodRoadCount()
    }

    handleReconnectSuccess(): void {
        console.log('SOCKET RECONNECTED')
        this.loadData(true)
        // this.loadGoodRoadCount()
    }

    handleOnBetSuccess(): void {
        // console.log('betSuceess')
        this.hasConfirmedBet = true
    }
    // stopRequestingCard() {
    //     this.clearAxiosRequest()
    //     if (typeof this.cardRequestTimeout === 'number') {
    //         clearTimeout(this.cardRequestTimeout)
    //         this.cardRequestTimeout = false
    //     }
    // }

    clearAxiosRequest() {
        if (AxiosSource) {
            AxiosSource.Source.cancel()
            AxiosSource.Source = axios.CancelToken.source()
        }
    }

    handleOnPredict(value: number): void {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const roadmapView = this.$refs['roadmapview'] as RoadMapView
        roadmapView.Predict(value)
    }

    getChipImageWebp(amount: number): string {
        return require(`@/assets/imgs/chips${amount}.webp`)
    }

    getChipImageWebpPng(amount: number): string {
        return require(`@/assets/imgs/chips${amount}.png`)
    }
    getCustomChipValue(): unknown {
        return this.customChipValue <= 0 ? '自定义' : this.customChipValue
    }

    UpdateRoadMapData(
        data: RoadMapData,
        nextRed: RoadMapData,
        nextBlue: RoadMapData
    ): void {
        this.roadMapSummaryData = {
            gameType: this.gameType,
            data: data
        }

        this.nextRedRoadMapSummaryData = { data: nextRed }
        this.nextBlueRoadMapSummaryData = { data: nextBlue }
    }

    loadData(_forceReload = false, reloadVideo = true): void {
        const params = new URLSearchParams(window.location.search)

        const _desk = params.get('desk')
        const _gameType = params.get('gameType')

        // console.log('LOAD DATA', { _desk, _gameType })

        if (!_desk || !_gameType) return

        if (!_forceReload) {
            this.showLoading()
        }

        const _params = {
            memberId: this.memberId,
            tableId: _desk,
            token: this.token,
            limitId: this.limitId
        }

        getTableInfo(_params)
            .then(r => {
                const response = r.data
                if (!_forceReload) this.hideLoading()
                if (response.status === 200) {
                    const tempDesk = response.data.gameTable
                    // console.log('TABLE INFO', tempDesk)
                    store.commit(DeskMutation.SET_CURRENT_DESK, tempDesk)

                    this.allowBet = tempDesk.expand.daoJiShiBetTime > 0
                    this.gameChips = tempDesk.expand.memberChipsShow
                        .split(',')
                        .map(Number)
                    store.commit(DeskMutation.SET_CHIP_VALUES, this.gameChips)

                    if (this.chipIndex === -1 && this.gameChips.length > 0) {
                        this.setCurrentChipIndex(0)
                    }
                    this.videos = [this.currentDesk.cmccLine]

                    // set personal limit
                    if (this.deskLimit) {
                        const {
                            superSixDownLimit,
                            superSixUpLimit,
                            upLimit,
                            downLimit,
                            limitMax,
                            tieDownLimit,
                            tieUpLimit,
                            pairDownLimit,
                            pairUpLimit,
                            bigTigerDownLimit,
                            bigTigerUpLimit,
                            smallTigerDownLimit,
                            smallTigerUpLimit,
                            dragonSevenDownLimit,
                            dragonSevenUpLimit,
                            bearEightDownLimit,
                            bearEightUpLimit
                        } = tempDesk

                        const _limit: MemberLimit = {
                            upLimit,
                            downLimit,
                            superSixDownLimit,
                            superSixUpLimit,
                            tieDownLimit,
                            tieUpLimit,
                            pairDownLimit,
                            pairUpLimit,
                            id: this.deskLimit.id,
                            bigTigerDownLimit,
                            bigTigerUpLimit,
                            smallTigerDownLimit,
                            smallTigerUpLimit,
                            dragonSevenDownLimit,
                            dragonSevenUpLimit,
                            bearEightDownLimit,
                            bearEightUpLimit
                        }

                        store.commit(DeskMutation.SET_DESK_LIMIT, _limit)
                    }

                    if (response.data.noticeList.length > 0) {
                        // save loby notice
                        let noticeContent = ''
                        response.data.noticeList.forEach((x, index) => {
                            let sufix = ''
                            if (index > 0) sufix = ', '
                            noticeContent += `${sufix}${x.content}`
                        })
                        store.commit(
                            DeskMutation.SET_DESK_NOTICE,
                            noticeContent
                        )
                    }

                    if (response.data.gameTable.expand.amount) {
                        store.commit(
                            UserMutation.SET_BET_COIN,
                            response.data.gameTable.expand.amount
                        )
                    }
                    if (reloadVideo) this.initVideoPlayer()
                } else if (response.status === 301) {
                    this.endService()
                    this.emitter.emit(EventBuss.SESSION_EXPIRED)
                }
            })
            .catch(e => {
                if (!axios.isCancel(e)) {
                    this.failureCounter += 1

                    if (!_forceReload) {
                        this.hideLoading()
                    }

                    if (this.failureCounter > 3) {
                        this.emitter.emit(
                            EventBuss.TOAST_MESSAGE,
                            this.iN('prompt.networkerror')
                        )

                        this.emitter.emit(EventBuss.SOCKET_CLOSE)
                        store.commit(UserMutation.DELETE_SESSION)
                        router.push({ name: ROUTES.LOGIN })

                        return
                    }

                    this.serviceTimeOut = setTimeout(() => {
                        this.loadData(true)
                    }, this.PULL_INTERVAL)
                }
            })
    }

    endService(): void {
        this.clearAxiosRequest()
        if (typeof this.serviceTimeOut === 'number') {
            clearTimeout(this.serviceTimeOut)
            this.serviceTimeOut = false
        }
        // this.stopRequestingCard()
    }

    startCountDown() {
        if (typeof this.countDownTimer !== 'number') {
            this.allowBet = true
            this.currentCount = this.currentDesk?.expand.daoJiShiBetTime ?? 0
            if (this.currentCount > 20) {
                audioPlayer.Play(SOUNDKEY.START_BET)
            }

            this.countDownTimer = setInterval(() => {
                if (this.currentCount < 0) {
                    if (this.playStopBet) {
                        this.playStopBet = false
                        audioPlayer.Play(SOUNDKEY.STOP_BET)
                    }
                    this.stopCountDown()
                } else {
                    if (this.currentCount <= 11 && this.currentCount > 0)
                        audioPlayer.Play(SOUNDKEY.TICK)
                    this.currentCount -= 1
                }
            }, 1000)
        }
    }

    stopCountDown() {
        if (typeof this.countDownTimer === 'number') {
            clearInterval(this.countDownTimer)
            this.countDownTimer = false
            this.currentCount = -1
            this.allowBet = false
            this.resetBetView()

            if (this.currentDesk) {
                this.currentDesk.status = 2
                this.currentDesk.expand.daoJiShiBetTime = -1
            }
        }
    }

    resetBetView(): void {
        const betview = this.$refs['betview'] as BetViewMixin
        if (betview) betview.resetBet()
    }

    hideGameResult(): void {
        const betview = this.$refs['betview'] as BetViewMixin
        if (betview) betview.hideGameResult()
    }

    showGameResult(): void {
        const betview = this.$refs['betview'] as BetViewMixin
        if (betview && this.currentGameResult)
            betview.showResult(this.currentGameResult)
    }

    // resetUI(data = ''): void {
    //     this.deskResult = data

    //     // check if super 6 mode has bet or banker super 6 mode has bet
    //     // if (
    //     //     this.currentDesk.hasBetOnSuper6 ||
    //     //     this.currentDesk.hasBetOnRedSuper6
    //     // )
    //     //     this.isSuper6Mode = true
    //     // if (this.currentDesk.hasBetOnSuper6 && !this.isSuper6Mode) {
    //     //     this.isSuper6Mode = true
    //     // }
    // }

    showPopAlert(model: PopAlertModel): void {
        this.alertMessage = model
        this.messageCounter = 9

        if (typeof this.messageInterval !== 'number') {
            this.messageInterval = setInterval(() => {
                this.messageCounter -= 1
                if (
                    this.messageCounter <= 0 &&
                    typeof this.messageInterval === 'number'
                ) {
                    clearInterval(this.messageInterval)
                    this.messageInterval = false
                }
            }, 500)
        }

        if (typeof this.alertTimer === 'number') {
            clearInterval(this.alertTimer)
            this.alertTimer = false
        }

        // this.alertMessage = model
        // this.hasPopAlert = true

        // this.alertTimer = setTimeout(() => {
        //     this.hasPopAlert = false
        //     this.alertMessage = undefined
        // }, 6000)
    }

    // stopRequestingVideoInfos() {
    //     if (typeof this.videoAxiosSource !== 'undefined') {
    //         this.videoAxiosSource.cancel()
    //         this.videoAxiosSource = axios.CancelToken.source()
    //     }

    //     if (typeof this.videoRequestTimeOut === 'number') {
    //         clearTimeout(this.videoRequestTimeOut)
    //         this.videoRequestTimeOut = false
    //     }
    // }

    //#endregion
    //#region Video Player
    async initVideoPlayer(): Promise<void> {
        this.videoIsLoading = true

        // 取消上一次还在进行中的 HTTP 请求，防止旧请求的回调干扰新台的播放
        if (this.videoAxiosSource) {
            this.videoAxiosSource.cancel()
        }
        this.videoAxiosSource = axios.CancelToken.source()

        // 每次调用生成新的会话 ID；async 等待结束后检查是否已被更新的调用取代
        const session = ++this.videoPlayerSession

        this.disposeVideoPlayer()

        // 从 cmccLine 提取路径，例如：
        //   http://mmm1.66286662.net:8091/mkk4/kkvideocg88.flv
        //   → mkk4/kkvideocg88.flv
        const cmccLine = (this.currentDesk?.cmccLine || '').split('$')[0]
        if (!cmccLine) return

        let videoPath = ''
        try {
            const parsed = new URL(cmccLine)
            videoPath = parsed.pathname.replace(/^\//, '')
        } catch {
            return
        }
        if (!videoPath) return

        // phpBase 跟随当前线路，子域名前缀加 xx
        // 例：https://api1.627283855.com → https://xxapi1.627283855.com
        const line: number = store.getters['serverLine']
        let apiBase = ''
        if (line === 1) apiBase = process.env.API_LINE1 || ''
        else if (line === 2) apiBase = process.env.API_LINE2 || ''
        else if (line === 3) apiBase = process.env.API_LINE3 || ''
        else if (line === -1) apiBase = store.getters['serverLineStr'] || ''
        else apiBase = process.env.API_LINE1 || ''
        const phpBase = apiBase.replace(/\/$/, '').replace(/\/\/api/, '//xxapi')

        // 调用 videoxx.php 获取签名后的视频地址列表
        let signedUrls: string[] = []
        try {
            const { data } = await axios.get<{ urls: string[] }>(
                `${phpBase}/videoxx.php`,
                {
                    params: { safeUrl: 'QWE~!@wwCa99AS', path: videoPath },
                    cancelToken: this.videoAxiosSource.token
                }
            )
            signedUrls = Array.isArray(data.urls) ? data.urls : []
        } catch {
            signedUrls = []
        }

        // 如果在等待期间用户已经切换到新台，本次调用作废
        if (session !== this.videoPlayerSession) return
        if (!signedUrls.length) return

        // 同时向所有线路发起连接，第一路 start → 赢家，立即停掉其余所有连接
        let won = false

        signedUrls.forEach(url => {
            const _player = new NodePlayer()
            _player.setVolume(0)
            _player.setView('videoplayer2')
            _player.setBufferTime(1000)
            _player.setScaleMode(2)

            _player.on('start', () => {
                if (session !== this.videoPlayerSession || won) {
                    _player.clearView()
                    _player.stop()
                    return
                }
                won = true
                this.nodePlayer = _player
                this.nodePlayer.clearView()
                this.nodePlayer.setView('videoplayer1')
                this.nodePlayer.on(
                    'buffer',
                    (evt: 'empty' | 'buffering' | 'full') => {
                        if (evt === 'empty' || evt === 'buffering') {
                            this.videoIsLoading = true
                        } else if (evt === 'full') {
                            this.videoIsLoading = false
                        }
                    }
                )
                this.nodePlayer.on('error', () => {
                    this.videoIsLoading = true
                    setTimeout(() => {
                        if (this.nodePlayer) {
                            this.nodePlayer.clearView()
                            this.nodePlayer.stop()
                        }
                        this.initVideoPlayer()
                    }, 1000)
                })
            })

            _player.on('error', () => {
                _player.clearView()
                _player.stop()
            })

            this.videoPlayerCollection.push(_player)
            _player.start(url)
        })
    }

    disposeVideoPlayer(): void {
        if (this.nodePlayer) {
            this.nodePlayer.stop()
            this.nodePlayer.clearView()
            this.nodePlayer = undefined
            this.videoIsLoading = true
        }

        this.videoPlayerCollection.forEach(_player => {
            if (_player) {
                _player.clearView()
                _player.stop()
            }
        })

        this.videoPlayerCollection = []
    }

    //#endregion
    //#region Click Events

    showChipDialog(isTrue: boolean): void {
        if (isTrue) {
            if (this.device.display !== 1) {
                this.showCustumChip = true
            } else {
                this.emitter.emit(EventBuss.SHOW_NUMERIC_KEYBOARD, true)
            }
        } else {
            if (this.customChipValue > 0) {
                if (this.chipIndex === 5) {
                    // this.chip = 0
                    this.setCurrentChipIndex(-1)
                } else {
                    this.setCurrentChipIndex(5)
                    // this.chip = this.customChipValue
                }
            } else {
                if (this.device.display !== 1) {
                    this.showCustumChip = true
                } else {
                    this.emitter.emit(EventBuss.SHOW_NUMERIC_KEYBOARD, true)
                }
            }
        }
    }

    ShowSwitchTable(): void {
        this.showSwicthTable = !this.showSwicthTable
        if (this.showSwicthTable) this.showGoodRoadPanel = false
    }
    OnCLickToggleFullScreen(): void {
        this.setFullScreen(!this.isFullScreen)
        if (!this.isFullScreen && screenfull.isEnabled) {
            const sc = screenfull as Screenfull
            sc.exit()
        }
    }

    chipClicked(index: number): void {
        if (index === this.chipIndex && this.chipIndex !== -1) {
            this.setCurrentChipIndex(-1)
            // this.chip = 0
            return
        }

        this.setCurrentChipIndex(index)
        // this.chip = amount
    }

    OnShowSwitchTable(): void {
        this.showSwicthTable = !this.showSwicthTable
        if (this.showSwicthTable) this.showGoodRoadPanel = false
    }

    OnShowGoodRoad(): void {
        this.showGoodRoadPanel = !this.showGoodRoadPanel
        if (this.showGoodRoadPanel) this.showSwicthTable = false
    }

    onGoodRoadSync(desksByType: { G002: Table[]; G003: Table[] }): void {
        this.goodRoadTablesCache = [
            ...(desksByType.G002 || []),
            ...(desksByType.G003 || [])
        ]
        this.recalculateGoodRoadCount()
    }

    loadGoodRoadCount(): void {
        if (!this.token) return

        getHallData({
            token: this.token,
            gameTypeNo: ''
        })
            .then(r => {
                if (r.data.status === 200) {
                    this.goodRoadTablesCache = filterGoodRoadGameTables(
                        r.data.data.gameTableList || []
                    )
                    this.recalculateGoodRoadCount()
                    return
                }

                if (r.data.status === 301) {
                    this.emitter.emit(EventBuss.SESSION_EXPIRED)
                }
            })
            .catch(error => {
                if (axios.isCancel(error)) return
            })
    }

    recalculateGoodRoadCount(): void {
        this.goodRoadCount = countGoodRoadTables(this.goodRoadTablesCache)
    }

    updateGoodRoadCacheTable(table: Table): void {
        if (table.gameTypeNo !== 'G002' && table.gameTypeNo !== 'G003') {
            return
        }

        const index = this.goodRoadTablesCache.findIndex(t => t.id === table.id)
        if (index !== -1) {
            this.goodRoadTablesCache.splice(index, 1, table)
        } else {
            this.goodRoadTablesCache.push(table)
        }

        this.recalculateGoodRoadCount()
    }

    syncGoodRoadCountFromSocket(_type: string, gameTable?: Table): void {
        if (
            _type !== SOCKET_MESSAGE.NEW_GAME &&
            _type !== SOCKET_MESSAGE.END_GAME &&
            _type !== SOCKET_MESSAGE.STOP_GAME &&
            _type !== SOCKET_MESSAGE.NEW_SHOE
        ) {
            return
        }

        if (!gameTable) return

        this.updateGoodRoadCacheTable(gameTable)
    }

    handleSwitchTable() {
        // stop count down
        // dispose video
        // stop pulling data if has pending request
        // hide cards display if showing
        // clear winner if animating
        // set win or loss amount
        // stop bet
        this.stopCountDown()
        this.allowBet = false
        this.hasConfirmedBet = false
        this.showPokerCards = false
        this.hideGameResult()
        this.resetBetView()
        this.videoIsLoading = true
        this.loadData()
    }

    onSwitchTable(desk: Table): void {
        if (typeof this.messageInterval === 'number') {
            clearInterval(this.messageInterval)
            this.messageCounter = 0
        }

        this.showSwicthTable = false
        this.endService()
        // this.stopRequestingCard()
        // this.stopRequestingVideoInfos()
        this.stopCountDown()

        // reset betting
        this.allowBet = false
        this.resetBetView()
        this.hideGameResult()

        // this.needReloadUI = true
        // this.resetUI()

        this.currentGameID = undefined
        // this.setCurrentDesk(desk)
        this.showPokerCards = false
        this.videos = []
        this.videoIsLoading = true

        this.loadData()

        // this.initVideoPlayer()
    }

    OnClickCustumerService(): void {
        window.open(process.env.VUE_APP_CUSTUMER_SERVICE, '_blank')
    }

    OnClickRules(): void {
        // window.open(
        //     'http://kkw6888.com/resource/rules/rule_home.html',
        //     '_blank'
        // )
        this.showRule = true
    }

    toggleSuper6Mode(isTrue: boolean): void {
        // if (this.hasConfirmedBet) return

        // console.log('TOGGLE SUPER 6 MODE', this.hasConfirmedBet)

        this.isSuper6Mode = isTrue
    }

    goToLoby() {
        router.push({ name: ROUTES.LOBY })
    }
    //#endregion
    //#region
    //#region Getter
    get title(): string {
        const _gameType = this.$route.query.gameType as string
        const _desk = this.$route.query.desk as string

        if (_gameType && _desk) {
            if (_gameType === 'G002') {
                return `百家乐 ${_desk} 号桌`
            } else if (_gameType === 'G003') {
                return `龙虎 ${_desk} 号桌`
            }
        }

        return ''
    }

    get deskGameId(): string {
        if (this.currentDesk) {
            return this.currentDesk.expand.gameNo
        }

        return ''
    }

    get redCount(): number {
        if (this.roadMapSummaryData.data)
            return this.roadMapSummaryData.data.redCount
        return 0
    }

    get blueCount(): number {
        if (this.roadMapSummaryData.data)
            return this.roadMapSummaryData.data.blueCount
        return 0
    }

    get greenCount(): number {
        if (this.roadMapSummaryData.data)
            return this.roadMapSummaryData.data.tieCount
        return 0
    }

    get redPairCount(): number {
        if (this.roadMapSummaryData.data)
            return this.roadMapSummaryData.data.redPairCount
        return 0
    }

    get bluePairCount(): number {
        if (this.roadMapSummaryData.data)
            return this.roadMapSummaryData.data.bluePairCount
        return 0
    }

    get timerColor(): string {
        if (this.currentCount > 20) {
            return 'green'
        } else if (this.currentCount <= 20 && this.currentCount > 10) {
            return 'orange'
        } else {
            return 'red'
        }
    }

    get chip(): number {
        if (this.chipIndex === 5) return this.customChipValue

        if (this.chipIndex === -1) return 0

        const amt = this.chips[this.chipIndex]
        if (amt) return amt
        return 0
    }

    get gameType(): string {
        const _gameType = this.$route.query.gameType as string

        if (_gameType) {
            return _gameType
        }

        return ''
    }

    get redLabel(): string {
        if (this.gameType === 'G002') return '庄'
        else if (this.gameType === 'G003') return '龙'

        return ''
    }

    get blueLabel(): string {
        if (this.gameType === 'G002') return '闲'
        else if (this.gameType === 'G003') return '虎'

        return ''
    }

    get shoe(): string {
        if (typeof this.currentDesk !== 'undefined')
            return String(this.currentDesk?.expand.shoeNo)
        return ''
    }
    get juNo(): string {
        if (this.currentDesk) return String(this.currentDesk.expand.juNo)
        return ''
    }
    get tableResult(): string {
        if (this.currentDesk)
            return this.currentDesk.expand.resultList.join('#')
        return ''
    }

    get urlQuery() {
        return {
            desk: this.router.query.desk,
            gameType: this.router.query.gameType
        }
    }

    //#endregion

    //#region Watcher

    @Watch('currentDesk', { immediate: true, deep: true })
    OnDeskResult(desk: Table): void {
        if (this.currentDesk) {
            if (this.currentDesk.expand.daoJiShiBetTime > 0) {
                this.startCountDown()
            } else {
                this.stopCountDown()
            }
        }
    }

    @Watch('customChipValue', { immediate: false })
    WatchCustumChipChange(value: number): void {
        if (value > 0) this.setCurrentChipIndex(5)
    }

    @Watch('urlQuery', { deep: true })
    onUrlQueryChange(newQury: any, oldQuery: any) {
        this.showSwicthTable = false
        this.showGoodRoadPanel = false
        this.handleSwitchTable()
    }
    //#endregion
}
